<script setup lang="ts">
const appConfig = useAppConfig()
const { accessibleItems } = useSidebar()

let isOpen = useState('collapse-open')
isOpen.value = false

const { fetchUser, user } = useDirectusAuth()

watchEffect(() => {
  if (appConfig.tairo.collapse?.navigation) {
    appConfig.tairo.collapse.navigation.items = accessibleItems.value
  }
})

const isAdminOrOrganizer = computed(() => {
  return ['admin', 'super-administrator'].includes(
    user.value?.role,
  )
})

useHead({
  script: computed(() => {
    if (!isAdminOrOrganizer.value) return []

    return [
      {
        async: true,
        defer: true,
        src: '/js/marker.js',
      },
    ]
  }),
})
</script>

<template>
  <TairoCollapseLayout :horizontal-scroll="true" :toolbar="false">
    <slot />
    <ModalWrapper />
  </TairoCollapseLayout>
</template>
